<template>
  <div class="extraInfo">
     <b-row>
       <b-col md="4">
          <div class="shippingType">
            <strong>Shipping :</strong> <img src="../../../assets/images/svg_icons/express-delivery.svg" alt="express" v-if="shippingType && shippingType.toLowerCase().includes('express')" width="25px"> <span>{{ shippingType ? shippingType : 'Unknown'  }}</span>
           </div>
       </b-col>
       <b-col md="5">
         <strong>Conv src :</strong> <span :class="{capitalize: sourceName.foundInArray}">{{ sourceName.name }}</span>
       </b-col>
     </b-row> 
  </div>
</template>

<script>
  export default {
     props: {
       conversionSource: {
         type: String,
         default: null
       },
       shippingType: {
         type: String,
         default: null
       }
     },
     data(){
       return {
         sources: ['facebook', 'instagram', 'bing', 'google', 'kmail-lists'],
         
       }
     },
     methods: {
       is_url(str)
        {
          let regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
                if (regexp.test(str))
                {
                  return true;
                }
                else
                {
                  return false;
                }
        }
     },
     computed: {
       sourceName(){
         
          const foundSource = this.sources.find(source => this.conversionSource && this.conversionSource.toLowerCase().includes(source));

          if(foundSource){
             return { foundInArray: true, name: foundSource }
          }
          else if(this.conversionSource && !foundSource){
            if(this.is_url(this.conversionSource)){
               return { foundInArray: false, name: this.conversionSource.match(/^https?:\/\/[^#?\/]+/)[0]}
            }
            return { foundInArray: false, name: "Unknown" }
          }
          else{
            return { foundInArray: false,   name: "Unknown" }
          }
       },
       shippingTypeModified(){
          if(this.shippingType && this.shippingType.toLowerCase().includes('express')){
            return 'Express Delivery';
          }
          else{
            return this.shippingType
          }
       }
     }
  }
</script>

<style lang="scss" scoped>
  .extraInfo{
    background-color: rgb(236, 242, 255);
    border-left: 2px solid rgb(38, 109, 252);
    border-right: 2px solid rgb(38, 109, 252);
    color: rgb(49, 59, 78);
    padding: 5px 10px;
    border-radius: 3px;
  }
  span.capitalize {
    text-transform: capitalize;
  }
  .shippingType{
    white-space: nowrap;
    overflow: hidden;
    span{
      background-color: rgb(236, 242, 255);
      position: relative;
      z-index: 2;
      
    }

    &:hover{
      overflow: visible;
      span{
        background-color: rgb(106, 152, 252);
        color: #fff;
      }
    }
  }

</style>